module.exports = __webpack_public_path__ + "img/grid-white.8931203e.svg";